// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import {
  IonAccordionGroup, IonAccordion, IonItem,
  IonLabel, IonSkeletonText
} from '@ionic/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import './MainMenuGroup.scss'
import useSession from './useSession'


interface MainMenuItemProps {
  children?: React.ReactElement | React.ReactNode | never[]
  icon?: IconDefinition
  title: string
  path?: string
  onClick?: () => void
  visible?: boolean
}


const MainMenuItemWithChildren: React.FC<MainMenuItemProps> = ({
  children,
  icon,
  title,
  ...props
}) => {
  const {ready} = useSession()
  return (
    <div className="item">
      <IonAccordionGroup>
        <IonAccordion>
          <IonItem slot="header" >
            <IonLabel style={{display: "flex"}}>
              <div
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  width: "32px"
                }}
              >
                <FontAwesomeIcon icon={icon as IconDefinition}/>
              </div>
              {(!!ready) ? title : (<IonSkeletonText animated={true}/>)}
            </IonLabel>
          </IonItem>
          <div slot="content" style={{fontSize: "11px", paddingLeft: "32px"}}>
            {children}
          </div>
        </IonAccordion>
      </IonAccordionGroup>
    </div>
  )
}

const MainMenuItemLink: React.FC<MainMenuItemProps> = ({
  icon,
  path,
  title,
  ...props
}) => {
  const {ready} = useSession()
  const onClick = props.onClick || (() => {})
  return (
    <IonItem lines="none" onClick={() => onClick()} routerLink={path}>
      <IonLabel style={{display: "flex"}}>
        <div
          style={{
            alignItems: "center",
            justifyContent: "center",
            width: "32px"
          }}
        >
          <FontAwesomeIcon icon={icon as IconDefinition}/>
        </div>
        {(!!ready) ? title : (<IonSkeletonText animated={true}/>)}
      </IonLabel>
    </IonItem>
  )
}

const MainMenuItem: React.FC<MainMenuItemProps> = ({
  children,
  ...props
}) => {
  const visible = (props.visible !== undefined) ? props.visible : true
  if (!visible) {
    return null
  }
  return (!!children)
    ? (<MainMenuItemWithChildren children={children} {...props}/>)
    : (<MainMenuItemLink {...props}/>)
}

export default MainMenuItem